import { Injectable, Inject, isDevMode, enableProdMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../_models/user';
//import { JsonpCallbackContext } from '@angular/common/http/src/jsonp';
import { Router } from '@angular/router';



@Injectable()
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  _user: User;

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private router: Router) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
    this._user = this.currentUserSubject.value;
    if (this._user) {
      //enableProdMode();
      //if (this._user.userName=="mbeck") this._user.role = 255;
      this.setActiveRole(this.getRoles()[0]);
    }
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(username: string, password: string) {

    return this.http.post<any>(this.baseUrl + '/users/authenticate', { "username": username, "passwort": password })
      .pipe(map(user => {
        console.log(user)
        // login successful if there's a jwt token in the response
        if (user && user.token) {
          // store user details and jwt token in session storage to keep user logged in between page refreshes
          sessionStorage.clear();
          sessionStorage.setItem('currentUser', JSON.stringify(user));
          console.log(JSON.stringify(user));
          this.currentUserSubject.next(user);
          this._user = this.currentUserSubject.value;
          if (this._user) {
            //if (this._user.userName == "mbeck") this._user.role = 255;
            this.setActiveRole(this.getRoles()[0]);
          }
        }

        return user;
      }));
  }

  logout() {
    // remove user from local storage to log user out
    sessionStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
    this._user = null;
  }





  getRoles(): string[] {

    if (this._user) {
      let roles: string[] = [];
      if (128 == (this._user.role & 128)) roles.push("Supervisor");
      if (64 == (this._user.role & 64)) roles.push("Management");
      if (32 == (this._user.role & 32)) roles.push("Role6");
      if (16 == (this._user.role & 16)) roles.push("Coach");
      if (8 == (this._user.role & 8)) roles.push("Role4");
      if (4 == (this._user.role & 4)) roles.push("Trainer");
      if (2 == (this._user.role & 2)) roles.push("Trainer (extern)");
      if (1 == (this._user.role & 1)) roles.push("Auditor");
      if (this._user.role === 0) roles.push("No Role");
      return roles;
    }
    return [""];
  }

  getActiveRoleName(): string {
    if (this._user) {
      if (128 == this._user.activeRole) return "Supervisor";
      if (64 == this._user.activeRole) return "Management";
      if (32 == this._user.activeRole) return "Role6";
      if (16 == this._user.activeRole) return "Coach";
      if (8 == this._user.activeRole) return "Role4";
      if (4 == this._user.activeRole) return "Trainer";
      if (2 == this._user.activeRole) return "Trainer (extern)";
      if (1 == this._user.activeRole) return "Auditor";
    }
    return "No Role";
  }

  setActiveRole(roleName: string) {
    switch (roleName) {
      case "Supervisor":
        this._user.activeRole = 128;
        break;
      case "Management":
        this._user.activeRole = 64;
        break;
      case "Role6":
        this._user.activeRole = 32;
        break;
      case "Coach":
        this._user.activeRole = 16;
        break;
      case "Role4":
        this._user.activeRole = 8;
        break;
      case "Trainer":
        this._user.activeRole = 4;
        break;
      case "Trainer (extern)":
        this._user.activeRole = 2;
        break;
      case "Auditor":
        this._user.activeRole = 1;
        break;
      default:
        this._user.activeRole = 0;
    }
    this.router.navigate(['home']);
  }

  public get user(): User {
    return this._user;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/authentication.service.ts